import { DeviceDTO } from '@eppendorf/vnls-device-service-utils';
import { Button, Dialog, Icon, IconSizeClasses } from '@eppendorf/vnls-react-components';
import { FunctionComponentElement, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { useAutoFocus } from '$shared/custom-hooks/useAutoFocus';

import { useContactSupport } from '$components/chat-bot/useContactSupport';
import { DeviceNameCell } from '$components/device/name-cell';
import { UnlessSenseMonitor } from '$components/unless-sense-monitor';

export interface ErrorScreenProps {
  onSubmit?: () => void;
  device?: DeviceDTO;
}

export function ErrorScreen({
  onSubmit,
  device,
}: ErrorScreenProps): FunctionComponentElement<ErrorScreenProps> {
  const { t } = useTranslation();
  const handleContactSupport = useContactSupport();
  const pairLaterButtonRef = useRef<null | HTMLButtonElement>(null);

  useAutoFocus(pairLaterButtonRef);

  return (
    <>
      <div className="flex flex__dir--column flex__ai--center p-l">
        <Icon
          name="info"
          className="bg-blue-500 m-bottom-xxl"
          size={IconSizeClasses.XLarge}
        />
        <Dialog.Title>{t('addDevice.addError')}</Dialog.Title>
        <div>
          <p>{t('addDevice.addErrorInfo')}</p>
          <div className="p-top-xxxl p-bottom-xxxl">
            {device && <DeviceNameCell device={device} />}
          </div>
          <p className="m-top-xl">
            <span>
              <UnlessSenseMonitor
                deviceModel={device?.model}
                fallback={t('addDevice.waitingInfoSenseMonitor')}
              >
                {t('addDevice.waitingInfo')}
              </UnlessSenseMonitor>
              {` ${t('errors.contactSupport')} `}
            </span>
            <Dialog.Close>
              <button
                type="button"
                onClick={handleContactSupport}
                className="btn-as-link font-weight-regular color-blue-500"
              >
                {t('errors.contactSupport2')}
              </button>
            </Dialog.Close>
          </p>
        </div>
      </div>
      <Dialog.Actions className="m-top-xxxl">
        <Dialog.Close>
          <Button variant="secondary">{t('shared.close')}</Button>
        </Dialog.Close>
        <Button onClick={onSubmit}>{t('shared.tryAgain')}</Button>
      </Dialog.Actions>
    </>
  );
}
